export const SUPPORT_BOT_HIDDEN_PATHS = [
  '/analytics/integration-health',
  '/analytics/integration-health/issue-log/:issueId',
  '/issuing/business-accounts/cards/:id',
  '/request-support',
  '/request-support/new',
  '/support',
  '/support/new',
  '/payments/payment-links/preview',
];
